import React from 'react'

const Profile = () => {
  return (
    <div className="container">Profile</div>
  )
}

export default Profile